import { render, staticRenderFns } from "./ResolucionTickets.vue?vue&type=template&id=2d08af67"
import script from "./ResolucionTickets.vue?vue&type=script&lang=js"
export * from "./ResolucionTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports